module.exports = __webpack_public_path__ + "img/home-modern-kitchen.b061bfb8.jpg";